import i18n from '../i18n';
import { TranslateResult } from 'vue-i18n';

export interface MicrocertificateStatus {
  id: number;
  minProgress: number;
  minRequirements: TranslateResult;
  discipline: TranslateResult;
  description?: TranslateResult;
}

const newbieStatus: MicrocertificateStatus = {
  id: 1,
  minProgress: 0,
  minRequirements: '',
  discipline: i18n.t('newbie'),
};

const interestedStatus: MicrocertificateStatus = {
  id: 2,
  minProgress: 25,
  minRequirements: '',
  discipline: i18n.t('interested'),
  description: i18n.t('interestedDescription'),
};

const enthusiasticStatus: MicrocertificateStatus = {
  id: 3,
  minProgress: 50,
  minRequirements: '',
  discipline: i18n.t('enthusiastic'),
  description: i18n.t('enthusiasticDescription'),
};

const specialistStatus: MicrocertificateStatus = {
  id: 4,
  minProgress: 75,
  minRequirements: i18n.t('specialistRequirements'),
  discipline: i18n.t('specialist'),
  description: i18n.t('specialistDescription'),
};

export const MICROCERTIFICATE_DATA: MicrocertificateStatus[] = [
  newbieStatus,
  interestedStatus,
  enthusiasticStatus,
  specialistStatus,
];

export const getMicrocertificateStatus = (progress: number): MicrocertificateStatus => {
  const newbieMicrocertificateIndex = 0;
  return MICROCERTIFICATE_DATA.reduce(
    (acc: MicrocertificateStatus, microcertificate: MicrocertificateStatus) => {
      return progress >= microcertificate.minProgress ? microcertificate : acc;
    },
    MICROCERTIFICATE_DATA[newbieMicrocertificateIndex],
  );
};
